import { createSelector } from 'reselect';
import { subselect } from './root';
import { idSelector } from './id';

const answersSelector = (trivia) => trivia.answers;

export const answerSelector = createSelector([answersSelector, idSelector], (answers, triviaId) => {
  let triviaAnswer;

  if (answers && triviaId && triviaId in answers) {
    triviaAnswer = answers[triviaId];
  }

  return triviaAnswer;
});

export const triviaAnswerSelector = subselect(answerSelector);
